export enum Flipper {
  ProductsViewPage = 'products_view_page',
  ProductsDownload = 'products_download',
  ProductsValueBasedOverrides = 'value_based_overrides',
  ProductSearchCPTButton = 'rt_catalog_product_search_report_cpt_problem',
}
